export var MuiCircularProgress = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        color: theme.palette.grey['400']
      };
    }
  }
};
//# sourceMappingURL=MuiCircularProgress.js.map